import React from 'react';
import urls, { codeUrl } from '@/constants/urls';
import CreatedWithUrlToast from '@/components/toasts/CreatedWithUrlToast';

const DatasetCreatedToast = ({ name, code }) => (
  <CreatedWithUrlToast
    className="aridhia-dataset-created-toast"
    messageId="toast.your.dataset"
    name={name}
    url={codeUrl(urls.DATASETS, code)}
  />
);

export default DatasetCreatedToast;
